/** Unique ids represented by a PolicyCard, including merged concatenate records. */
export const getGroupedFeedbackIds = (
  concatenateFeedbacks: Array<{ id: string }>,
  representativeId?: string,
): string[] => [
  ...new Set(
    [representativeId, ...concatenateFeedbacks.map((feedback) => feedback.id)].filter(
      (id): id is string => Boolean(id),
    ),
  ),
];
